export default {
  GUARDED: 'guarded', // ผิดปกติ
  TUMOR: 'tumor', // เนื้องอก
  FROWN: 'frown' // นิ่ว
}
